module.exports = __webpack_public_path__ + "img/jiatingcuneng.ec2572cd.png";